module.exports = __webpack_public_path__ + "static/media/mobile.77c561f0.png";